import type { LucideIcon } from 'lucide-react';
import { cn } from '@/shared/utils/cn';

type KPICardTrend = {
  value: string;
  isPositive: boolean;
};

type KPICardProps = {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: LucideIcon;
  trend?: KPICardTrend;
  className?: string;
};

export const KPICard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  className,
}: KPICardProps) => {
  return (
    <div className={cn('bg-white rounded-lg border border-gray-200 p-6', className)}>
      <div className="flex items-start justify-between mb-4">
        <div className="text-sm text-gray-600">{title}</div>
        {Icon && (
          <div
            data-testid="kpi-icon"
            className="w-10 h-10 rounded-lg bg-[#3d6560]/10 flex items-center justify-center"
          >
            <Icon className="w-5 h-5 text-[#3d6560]" />
          </div>
        )}
      </div>
      <div className="mb-1">
        <div className="text-3xl font-medium">{value}</div>
      </div>
      {subtitle && <div className="text-sm text-gray-500">{subtitle}</div>}
      {trend && (
        <div
          className={cn(
            'text-sm mt-2',
            trend.isPositive ? 'text-green-600' : 'text-red-600',
          )}
        >
          {trend.isPositive ? '↑' : '↓'} {trend.value}
        </div>
      )}
    </div>
  );
};
